import firebase from '../../services/firebase';
import {
  setProducts,
  setFeaturedProducts,
  setRecommendedProducts,
  setPickles,
  setPowders,
  setSweets,
  setSnacks,
  setSelectedProduct
} from '../productsSlice';

export const fetchProducts = () => async (dispatch) => {
  try {
    const { products, lastKey, total } = await firebase.getProducts();
    dispatch(setProducts({ products, lastKey, total }));
  } catch (error) {
    console.error('Error fetching products:', error);
  }
};

export const fetchFeaturedProducts = () => async (dispatch) => {
  try {
    const snapshot = await firebase.getFeaturedProducts();
    const featuredProducts = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    dispatch(setFeaturedProducts(featuredProducts));
  } catch (error) {
    console.error('Error fetching featured products:', error);
  }
};

export const fetchRecommendedProducts = () => async (dispatch) => {
  try {
    const snapshot = await firebase.getRecommendedProducts();
    const recommendedProducts = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    dispatch(setRecommendedProducts(recommendedProducts));
  } catch (error) {
    console.error('Error fetching recommended products:', error);
  }
};

export const fetchPickles = () => async (dispatch) => {
  try {
    const { pickles } = await firebase.getPickles();
    dispatch(setPickles(pickles));
  } catch (error) {
    console.error('Error fetching pickles:', error);
  }
};

export const fetchProductById = (productId) => async (dispatch) => {
  try {
    const productSnapshot = await firebase.getSingleProduct(productId);
    if (productSnapshot.exists) {
      const product = { id: productSnapshot.id, ...productSnapshot.data() };
      dispatch(setSelectedProduct(product));
    } else {
      console.log('Product not found');
    }
  } catch (error) {
    console.error('Error fetching product:', error);
  }
};

export const fetchPowders = () => async (dispatch) => {
  try {
    const { powders } = await firebase.getPowders();
    dispatch(setPowders(powders));
  } catch (error) {
    console.error('Error fetching powders:', error);
  }
};

export const fetchSweets = () => async (dispatch) => {
  try {
    const { sweets } = await firebase.getSweets();
    dispatch(setSweets(sweets));
  } catch (error) {
    console.error('Error fetching sweets:', error);
  }
};

export const fetchSnacks = () => async (dispatch) => {
  try {
    const { snacks } = await firebase.getSnacks();
    dispatch(setSnacks(snacks));
  } catch (error) {
    console.error('Error fetching snacks:', error);
  }
};